/**
 * Кастомный выпадающий список
 *
 * @param {HTMLElement} select - заменяемые select
 * @param {string} defaultText - текст для выбора option
 */
function createCustomSelect(select, defaultText = "") {
    select.style.display = "none"; // Скрываем стандартный select

    const isMultiple = select.hasAttribute('multiple');
    
    // Ищем кастомный placeholder элемент
    let customPlaceholderText = null;
    const selectName = select.getAttribute('name');
    if (selectName) {
        // Убираем [] из name если есть (например, "contacts-machine[]" -> "contacts-machine")
        const cleanName = selectName.replace(/\[\]$/, '');
        const placeholderElement = document.getElementById(`${cleanName}-placeholder`);
        if (placeholderElement && placeholderElement.classList.contains('dropdown-placeholder')) {
            customPlaceholderText = placeholderElement.textContent.trim();
        }
    }
    
    const wrapper = document.createElement("div");
    wrapper.className = "custom-select-wrapper";
    // Добавляем атрибут для связи с оригинальным элементом
    wrapper.setAttribute('data-custom-for', select.id);
    // Если сервер/JS уже пометили селект как ошибочный — перенесем на видимую обертку
    if (select.classList.contains('has-error') || select.dataset.hasError === '1') {
        wrapper.classList.add('has-error');
    }

    const dropdown = document.createElement("div");
    dropdown.className = "custom-dropdown";
    if (isMultiple) {
        dropdown.classList.add("custom-dropdown-multiple");
    }
    // Добавляем атрибут для связи с оригинальным элементом
    dropdown.setAttribute('data-custom-for', select.id);

    const selected = document.createElement("div");
    selected.className = "custom-dropdown-selected";

    // Для множественного выбора создаем контейнер для тегов
    let tagsContainer = null;
    if (isMultiple) {
        tagsContainer = document.createElement("div");
        tagsContainer.className = "custom-dropdown-tags";
        selected.appendChild(tagsContainer);
        
        const placeholder = document.createElement("span");
        placeholder.className = "custom-dropdown-placeholder";
        // Используем кастомный текст или дефолтный
        placeholder.textContent = customPlaceholderText || "Выберите варианты";
        selected.appendChild(placeholder);
    }

    const list = document.createElement("ul");
    list.className = "custom-dropdown-list";

    // Для множественного выбора храним массив выбранных значений
    let selectedValues = [];
    if (isMultiple) {
        // Получаем все выбранные опции
        Array.from(select.options).forEach(option => {
            if (option.selected) {
                selectedValues.push(option.value);
            }
        });
    } else {
        // Для одиночного выбора
        let selectedValue = select.options[select.selectedIndex]?.value || "";
        // Используем кастомный текст или дефолтный
        let selectedText = select.options[select.selectedIndex]?.textContent || (customPlaceholderText || "Выберите вариант");

        // Если передан `defaultText`, ищем его в `option`
        if (defaultText) {
            Array.from(select.options).forEach(option => {
                if (option.textContent.trim() === defaultText.trim()) {
                    selectedValue = option.value;
                    selectedText = option.textContent;
                    select.value = selectedValue; // Устанавливаем значение в стандартный select
                }
            });
        }

        selected.textContent = selectedText;

        // Добавляем класс not-selected если нет выбранного значения
        if (!selectedValue || selectedValue === '') {
            dropdown.classList.add('not-selected');
        }
    }
    
    // Обрабатываем required атрибут
    const isRequired = select.hasAttribute('required');
    if (isRequired) {
        // Убираем required с оригинального select'а, чтобы избежать ошибки браузера
        select.removeAttribute('required');
        // Добавляем визуальную индикацию обязательности
        dropdown.classList.add('required');
        // Добавляем атрибут для валидации
        dropdown.setAttribute('data-required', 'true');
    }

    // Функция для обновления отображения выбранных элементов (для множественного выбора)
    function updateMultipleDisplay() {
        if (!isMultiple) return;
        
        tagsContainer.innerHTML = '';
        const placeholder = selected.querySelector('.custom-dropdown-placeholder');
        
        if (selectedValues.length === 0) {
            dropdown.classList.add('not-selected');
            if (placeholder) placeholder.style.display = 'inline';
        } else {
            dropdown.classList.remove('not-selected');
            if (placeholder) placeholder.style.display = 'none';
            
            selectedValues.forEach(value => {
                const option = Array.from(select.options).find(opt => opt.value === value);
                if (option) {
                    const tag = document.createElement("span");
                    tag.className = "custom-dropdown-tag";
                    tag.textContent = option.textContent;
                    
                    const removeBtn = document.createElement("span");
                    removeBtn.className = "custom-dropdown-tag-remove";
                    removeBtn.innerHTML = "×";
                    removeBtn.addEventListener("click", function(e) {
                        e.stopPropagation();
                        removeValue(value);
                    });
                    
                    tag.appendChild(removeBtn);
                    tagsContainer.appendChild(tag);
                }
            });
        }
    }

    // Триггерим события на оригинальном select так, чтобы они всплывали (bubbles=true),
    // иначе обработчики вида form.addEventListener('change', ...) не сработают.
    function dispatchNativeSelectEvents() {
        try {
            select.dispatchEvent(new Event("change", { bubbles: true }));
        } catch (e) {
            // Фолбэк для старых браузеров
            const evt = document.createEvent("Event");
            evt.initEvent("change", true, true);
            select.dispatchEvent(evt);
        }
        try {
            select.dispatchEvent(new Event("input", { bubbles: true }));
        } catch (e) {
            const evt2 = document.createEvent("Event");
            evt2.initEvent("input", true, true);
            select.dispatchEvent(evt2);
        }
    }

    // Функция для добавления значения (для множественного выбора)
    function addValue(value) {
        if (!selectedValues.includes(value)) {
            selectedValues.push(value);
            // Обновляем оригинальный select
            const option = Array.from(select.options).find(opt => opt.value === value);
            if (option) {
                option.selected = true;
            }
            // Добавляем класс active у соответствующего элемента списка
            const listItem = list.querySelector(`li[data-value="${value}"]`);
            if (listItem) {
                listItem.classList.add("active");
            }
            updateMultipleDisplay();
            dispatchNativeSelectEvents();
        }
    }

    // Функция для удаления значения (для множественного выбора)
    function removeValue(value) {
        selectedValues = selectedValues.filter(v => v !== value);
        // Обновляем оригинальный select
        const option = Array.from(select.options).find(opt => opt.value === value);
        if (option) {
            option.selected = false;
        }
        // Убираем класс active у соответствующего элемента списка
        const listItem = list.querySelector(`li[data-value="${value}"]`);
        if (listItem) {
            listItem.classList.remove("active");
        }
        updateMultipleDisplay();
        dispatchNativeSelectEvents();
    }

    // Заполняем список элементами
    Array.from(select.options).forEach(option => {
        if (option.disabled) return;
        const li = document.createElement("li");
        li.textContent = option.textContent;
        li.dataset.value = option.value;

        if (isMultiple) {
            // Для множественного выбора проверяем, выбрана ли опция
            if (option.selected || selectedValues.includes(option.value)) {
                li.classList.add("active");
                if (!selectedValues.includes(option.value)) {
                    selectedValues.push(option.value);
                }
            }
        } else {
            // Для одиночного выбора
            if (option.value === (select.options[select.selectedIndex]?.value || "")) {
                li.classList.add("active");
            }
        }

        li.addEventListener("click", function (e) {
            e.stopPropagation();
            
            if (isMultiple) {
                // Для множественного выбора переключаем выбор
                if (this.classList.contains("active")) {
                    this.classList.remove("active");
                    removeValue(this.dataset.value);
                } else {
                    this.classList.add("active");
                    addValue(this.dataset.value);
                }
                // Не закрываем список для множественного выбора
            } else {
                // Для одиночного выбора
                selected.textContent = this.textContent;
                select.value = this.dataset.value;
                dispatchNativeSelectEvents(); // Триггерим change/input с bubbles=true
                dropdown.classList.remove("open");

                // Убираем класс not-selected при выборе значения
                dropdown.classList.remove("not-selected");

                // Убираем старый активный класс и добавляем новый
                list.querySelectorAll("li").forEach(item => item.classList.remove("active"));
                this.classList.add("active");
            }
        });

        list.appendChild(li);
    });

    // Инициализируем отображение для множественного выбора
    if (isMultiple) {
        updateMultipleDisplay();
    }

    dropdown.appendChild(selected);
    dropdown.appendChild(list);
    wrapper.appendChild(dropdown);
    select.parentNode.insertBefore(wrapper, select);

    // Открытие списка
    selected.addEventListener("click", function (e) {
        e.stopPropagation();
        const isOpen = dropdown.classList.contains("open");

        closeAllCustomSelects();

        if (!isOpen) {
            dropdown.classList.add("open");
        }
    });

    // Закрытие при клике вне
    document.addEventListener("click", function () {
        dropdown.classList.remove("open");
    });

    function closeAllCustomSelects() {
        document.querySelectorAll(".custom-dropdown.open").forEach(el => el.classList.remove("open"));
    }
}

document.addEventListener("DOMContentLoaded", function() {
    const selects = document.querySelectorAll("select");
    selects.forEach(select => {
        createCustomSelect(select);
    });
});